import { render, staticRenderFns } from "./orgTree.vue?vue&type=template&id=11489dd1&scoped=true&"
import script from "./orgTree.vue?vue&type=script&lang=js&"
export * from "./orgTree.vue?vue&type=script&lang=js&"
import style0 from "./orgTree.vue?vue&type=style&index=0&id=11489dd1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11489dd1",
  null
  
)

export default component.exports